import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import Select, { components } from 'react-select';
import { selectTransp, getTransp } from '../../store/Transportadora';

const { ValueContainer, Placeholder } = components;

const SelectTransportadora = ({ initialValue }) => {
  const { optionsSelect, selectTransportadora } = useSelector(state => state.transpReduce);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTransp());
    if (initialValue) {
      dispatch(selectTransp(initialValue));
    }
  }, [dispatch, initialValue]);

  const CustomValueContainer = ({ children, ...props }) => {
    return (
      <ValueContainer {...props}>
        <Placeholder {...props} isFocused={props.isFocused}>
          {props.selectProps.placeholder}
        </Placeholder>
        {React.Children.map(children, (child) =>
          child && child.type !== Placeholder ? child : null
        )}
      </ValueContainer>
    );
  };

  return (
    <div className="w-full">
      {/* {console.log("testetete", selectTransportadora.idTransp)} */}
      <Select
        value={optionsSelect.find(opt => String(opt.value) === String(selectTransportadora?.idErpTransp)) || null}
        onChange={(selectedOption) => {
          const newValue = selectedOption ? selectedOption.value : null;
          dispatch(selectTransp(newValue));
        }}
        isClearable={true}
        isSearchable={true}
        options={optionsSelect}
        components={{ ValueContainer: CustomValueContainer }}
        placeholder="Transportadora"
        styles={{
          container: (provided, state) => ({
            ...provided,
            marginTop: 10
          }),
          valueContainer: (provided, state) => ({
            ...provided,
            overflow: "visible",
            marginTop: 20
          }),
          placeholder: (provided, state) => ({
            ...provided,
            position: "absolute",
            top: -15,
            backgroundColor: "transparent",
            fontSize: 14
          })
        }}
      />
    </div>
  );
}

export default SelectTransportadora;
